'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext, useEffect, useState } from 'react';

import { PreviousPathnameContext } from 'contexts/PreviousPathnameContext';
import { useRouter } from 'next-nprogress-bar';
import { usePathname } from 'next/navigation';

import ButtonCircle from 'components/ui/ButtonCircle';
import Text from 'components/ui/Text';

import styles from './RecipeDetail.module.scss';

const BackButton = () => {
    const router = useRouter();
    const pathname = usePathname();

    const previousPathname = useContext(PreviousPathnameContext);
    const [previousPath, setPreviousPath] = useState(undefined);

    useEffect(() => {
        if (!router.isReady) return;
        previousPathname !== pathname && setPreviousPath(previousPathname);
    }, [previousPathname, pathname, router.isReady]);

    const handlePreviousClick = () => {
        previousPath?.includes('/recipes/filters')
            ? router.back()
            : router.push('/recipes');
    };

    return (
        <button
            type="button"
            className={styles.navButton}
            onClick={handlePreviousClick}
        >
            <ButtonCircle
                as="span"
                className={styles.navCaret}
                theme="small-fill-white"
                iconType="chevronLeft"
            />
            <Text
                as="span"
                baseTheme="labelSmall"
                themes={{ large: 'labelMedium' }}
                className={styles.navLabel}
            >
                back to recipes
            </Text>
        </button>
    );
};

export default BackButton;
